const WorksHyfye = () => { 
  return (
    <section id="how_it_work" className="bg_black_dark overflow_hide">
      <div className="container">
        <div className="row">

          {/* Left Title Section */}
          <div className="col-lg-4">
            <div className="title_default_light title_border">
              <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">How Hyfye Works</h4>
              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                Hyfye is your gateway to real-world Web3 utility. It enables you to participate in finance, gaming, content creation, social media, marketplaces, and more — all powered by the HYE token.
              </p>
              <a href="https://www.pinksale.finance/launchpad/bsc/0x5de2d1644cbde0db29b8Ab81CaD2A85e4ccfeD36"
                className="btn btn-default page-scroll video animation" 
                data-animation="fadeInUp" data-animation-delay="0.6s" target="_blank">
                Get Started <i className="ion-ios-arrow-thin-right"></i>
              </a>
            </div>
          </div>

          {/* Steps Section */}
          <div className="col-lg-8">
            <div className="row">

              {/* Step 1 */}
              <div className="col-lg-6">
                <div className="work_box res_md_mt_20">
                  <div className="work_icon animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                    <i className="ion-card"></i>
                  </div>
                  <div className="work_inner">
                    <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Set Up Your Wallet</h4>
                    <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                      Connect a crypto wallet like MetaMask or TrustWallet to access the Hyfye ecosystem.
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 2 */}
              <div className="col-lg-6">
                <div className="work_box res_md_mt_20">
                  <div className="work_icon animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                    <i className="ion-android-share-alt"></i>
                  </div>
                  <div className="work_inner">
                    <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Explore Mini Apps</h4>
                    <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                      Use HYE across various platforms - including financial tools, games, content platforms, social media, fitness trackers, marketplaces, and more.
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 3 */}
              <div className="col-lg-6">
                <div className="work_box mt-4">
                  <div className="work_icon animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                    <i className="ion-ios-analytics-outline"></i>
                  </div>
                  <div className="work_inner">
                    <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">Track & Earn</h4>
                    <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
                      HYE tracks your verified activity across mini-apps, enabling real world utility and value creation in a unified token economy.
                    </p>
                  </div>
                </div>
              </div>

              {/* Step 4 */}
              <div className="col-lg-6">
                <div className="work_box mt-4">
                  <div className="work_icon animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                    <i className="ion-android-people"></i>
                  </div>
                  <div className="work_inner">
                    <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Participate in Growth</h4>
                    <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                      As more apps and users join Hyfye ecosystem, your utility, earning potential and network reach grow - helping a truly interconnected Web3 ecosystem.
                    </p>
                  </div>
                </div>
              </div>

            </div> 
          </div>

        </div>
      </div>

      {/* Background Ripple Effects */}
      <div className="ripple_effect_left_bottom">
        <div className="circle_bg1">
          <span></span><span></span><span></span><span></span><span></span><span></span>
        </div>
      </div>
      <div className="ripple_effect_right_top">
        <div className="circle_bg1">
          <span></span><span></span><span></span><span></span><span></span><span></span>
        </div>
      </div>
    </section>
  );
}

export default WorksHyfye;
